<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Revue de l'Ecole" />
            <LaRevue />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LaRevue from './LaRevue.vue';

export default {
    name: 'LesTuteursPage',
    components: {
        NavBar,
        PageTitle,
        LaRevue,
        FooterComp,
    }
}
</script>